import React from 'react'
import "./css/Footer.css"
import { Link } from 'react-router-dom';
import { links, social } from './data'
function Footer() {
    return (
        <div className="footer">
            <h1>Thank you for Visiting!</h1>
            <div className="social">
                {social.map((item)=>{
                     const {id,url,icon,name}=item;
                     return <a className="link" href={url} key={id}>{icon} {name}</a>
                })}
            </div>
        </div>
    )
}

export default Footer
